export const getNewsDetailKey = (collection, id, lang) => `${collection}<${id},${lang}>`;
